export const ReadonlyBadge = () => {
  return (
    <span className="mr-auto px-1 rounded-[0.25rem]  bg-red-600 hidden sm:inline-flex leading-[1.25rem] text-[0.75rem] text-[#FBFBFD]">readonly</span>
  )
}